import { useState, useEffect, memo } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { checkboxData } from "./checkboxData";
import "./style.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { venueTtkSchema } from "../schemas";
import { useFormik } from "formik";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from "./ThinksToKnowStatus";

const VenueTTK = () => {
  const { language, currency } = useUserAuth();
  const {
    djPolicyOption,
    decorPolicyOption,
    caterPolicyOptions,
    alcoholPolicyOption,
    workSinceOption,
    spaceOption,
    smallPartyOption,
  } = checkboxData;
  const { user, token } = useUserAuth();
  const merchant_id = user.uid;
  const [merchant, setMerchant] = useState({});
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [ttkEditMode, setTtkEditMode] = useState(false);

  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      const data = res.data.data;
      const details = data[0].details;
      if (details) {
        const keysLength = Object.keys(details)?.length;
        setMerchant(data[0].details);
        formik.setValues(data[0].details);
      }
    } catch (error) {
      console.log(`Error : ${error}`);
    }
  };
  useEffect(() => {
    if (!merchant_id) return
    getSingleDocumentHandler();
  }, [merchant_id, token]);
  const formik = useFormik({
    initialValues: {
      parkingSize: merchant?.parkingSize || "",
      vegPrice: Math.floor(merchant?.vegPrice * currency.value) || "",
      nonVegPrice: Math.floor(merchant?.nonVegPrice * currency.value) || "",
      roomCount: merchant?.roomCount || "",
      avgRoomPrice: Math.floor(merchant?.avgRoomPrice * currency.value) || "",
      venueCapacity: merchant?.venueCapacity || "",
      starRating: merchant?.starRating || "",
      startingPrice: Math.floor(merchant?.startingPrice * currency.value) || "",
      workingSince: merchant?.workingSince || [],
      smallPartiesVenue: merchant?.smallPartiesVenue || [],
      space: merchant?.space || [],
      catering: merchant?.catering || [],
      decorPolicy: merchant?.decorPolicy || [],
      alcoholPolicy: merchant?.alcoholPolicy || [],
      djPolicy: merchant?.djPolicy || [],
    },
    enableReinitialize: true,
    validationSchema: venueTtkSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          id: merchant_id,
          details: {
            ...values,
            vegPrice: Math.floor(values.vegPrice * currency.country_value),
            nonVegPrice: Math.floor(values.nonVegPrice * currency.country_value),
            avgRoomPrice: Math.floor(values.avgRoomPrice * currency.country_value),
            startingPrice: Math.floor(values.startingPrice * currency.country_value)
          },
        };
        const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res.status === 201) {
          toast.success("Things to know added successfully.");
        } else if (res.status === 202) {
          toast.success("Your update is pending approval by the admin.");
        } else {
          toast.info(res.data.message || "Request submitted.");
        }
        setTtkEditMode(!ttkEditMode);
        const updated_data = {
          ...merchant,
          thingsToKnow: {
            ...values,
          },
        };
        setMerchant(updated_data);
        getSingleDocumentHandler();
      } catch (error) {
        console.error(`Error ${error}`);
        toast.error("An error occurred while updating the data.");
      }
    },
  });
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <ThinksToKnowStatus />
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header  text-white text-center "
                style={{ backgroundColor: "#085f9a" }}
              >
                <h5>
                  {language === "en"
                    ? "Things to Know"
                    : "जानने योग्य जानकारी भरे"}
                </h5>
              </div>
              <div className="card-body">
                {merchant && (
                  <>
                    <div className="table-responsive">
                      <table
                        className="table text-center"
                        cellPadding={0}
                        cellSpacing={0}
                        style={{ border: "1px solid #fff " }}
                      >
                        <tbody className="ttk_preview">
                          <tr style={{ color: "#41B0FA" }}>
                            <th style={{ width: "25%" }}>Working Since</th>
                            <th style={{ width: "25%" }}>Max Capacity </th>
                            <th style={{ width: "25%" }}>
                              How many cars can be parked at your venue?{" "}
                            </th>
                            <th style={{ width: "25%" }}>
                              Starting Veg Price (Per Plate){" "}
                            </th>
                          </tr>
                          <tr>
                            <td>
                              {merchant.workingSince?.map((item, index) => {
                                return <p key={index}>{item.value}</p>;
                              })}
                            </td>
                            <td>{merchant?.venueCapacity}</td>
                            <td>{merchant?.parkingSize}</td>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.vegPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                              <small
                                className="text-success"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                Per Plate
                              </small>
                            </td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            <th>Starting Non Veg Price (Per Plate)</th>
                            <th>Small Party Venue</th>
                            <th>Space</th>
                            <th>Total No. of Rooms</th>
                          </tr>
                          <tr>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.nonVegPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                              <small
                                className="text-danger"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                Per Plate
                              </small>
                            </td>
                            <td>
                              {merchant.smallPartiesVenue?.map(
                                (item, index) => {
                                  return <p key={index}>{item.value}</p>;
                                }
                              )}
                            </td>
                            <td>
                              {merchant.space?.map((item, index) => {
                                return (
                                  <p key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </p>
                                );
                              })}
                            </td>
                            <td>{merchant?.roomCount}</td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            <th>Avg Room Price</th>
                            <th>Catering Policy</th>
                            <th>Decor Policy</th>
                            <th>Alcohol Policy </th>
                          </tr>
                          <tr>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.avgRoomPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                            </td>
                            <td>
                              {merchant.catering?.map((item, index) => {
                                return (
                                  <p key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </p>
                                );
                              })}
                            </td>

                            <td>
                              {merchant.decorPolicy?.map((item, index) => {
                                return (
                                  <p key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span >{item.value} </span>
                                  </p>
                                );
                              })}
                            </td>
                            <td>
                              {merchant.alcoholPolicy?.map((item, index) => {
                                return (
                                  <p key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span key={index}>{item.value} </span>
                                  </p>
                                );
                              })}
                            </td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            <th>Star Rating</th>
                            <th>BuyOut Price</th>
                          </tr>
                          <tr>
                            <td>{merchant.starRating}</td>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.startingPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                <center>
                  <button
                    className="btn btn-primary mb-2 text-white"
                    style={{ backgroundColor: "#085f9a" }}
                    onClick={() => setTtkEditMode(!ttkEditMode)}
                  >{`${merchant ? "Make Changes" : "Tell me more about yourself"
                    }`}</button>
                </center>
                {ttkEditMode && (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Working Since <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={workSinceOption}
                            selected
                            value={formik.values.workingSince}
                            onChange={(workingSince) =>
                              formik.setFieldValue("workingSince", workingSince)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.workingSince &&
                            formik.errors.workingSince ? (
                            <div className="text-danger">
                              {formik.errors.workingSince}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            How many cars can be parked at your venue?{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="How many cars can be parked at your venue?"
                            name="parkingSize"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.parkingSize}
                          />
                          {formik.touched.parkingSize &&
                            formik.errors.parkingSize ? (
                            <div className="text-danger">
                              {formik.errors.parkingSize}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="" htmlFor="inlineFormInputGroup">Starting Veg Price (Per Plate)<span className="text-danger">*</span></label>
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">{currency?.symbol}</div>
                          </div>
                          <input type="number"
                            placeholder="Veg Price Per Plate"
                            className="form-control"
                            name="vegPrice"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.vegPrice} />
                        </div>
                        {formik.touched.vegPrice && formik.errors.vegPrice ? (
                          <div className="text-danger">
                            {formik.errors.vegPrice}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-6">
                        <label className="" htmlFor="inlineFormInputGroup">Starting Non Veg Price (Per Plate)<span className="text-danger">*</span></label>
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">{currency?.symbol}</div>
                          </div>
                          <input type="number"
                            placeholder="Non Veg Price Per Plate"
                            className="form-control"
                            name="nonVegPrice"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.nonVegPrice} />
                        </div>
                        {formik.touched.nonVegPrice && formik.errors.nonVegPrice ? (
                          <div className="text-danger">
                            {formik.errors.nonVegPrice}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Small Party Venue{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={smallPartyOption}
                            selected
                            value={formik.values.smallPartiesVenue}
                            onChange={(smallPartiesVenue) =>
                              formik.setFieldValue(
                                "smallPartiesVenue",
                                smallPartiesVenue
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.smallPartiesVenue &&
                            formik.errors.smallPartiesVenue ? (
                            <div className="text-danger">
                              {formik.errors.smallPartiesVenue}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Space <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={spaceOption}
                            selected
                            value={formik.values.space}
                            onChange={(space) =>
                              formik.setFieldValue("space", space)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.space && formik.errors.space ? (
                            <div className="text-danger">
                              {formik.errors.space}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Total No. of Rooms{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Total No. of Rooms"
                            name="roomCount"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.roomCount}
                          />
                          {formik.touched.roomCount &&
                            formik.errors.roomCount ? (
                            <div className="text-danger">
                              {formik.errors.roomCount}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Average Room Price{" "}
                            <span className="text-danger">*</span>
                          </label>
                             <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">{currency?.symbol}</div>
                          </div>
                          <input
                            type="number"
                            placeholder="Average Room Price"
                            name="avgRoomPrice"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.avgRoomPrice}
                          />
                          </div>
                          {formik.touched.avgRoomPrice &&
                            formik.errors.avgRoomPrice ? (
                            <div className="text-danger">
                              {formik.errors.avgRoomPrice}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Catering Policy{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={caterPolicyOptions}
                            selected
                            value={formik.values.catering}
                            onChange={(catering) =>
                              formik.setFieldValue("catering", catering)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.catering && formik.errors.catering ? (
                            <div className="text-danger">
                              {formik.errors.catering}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Decor Policy <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={decorPolicyOption}
                            selected
                            value={formik.values.decorPolicy}
                            onChange={(decorPolicy) =>
                              formik.setFieldValue("decorPolicy", decorPolicy)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.decorPolicy &&
                            formik.errors.decorPolicy ? (
                            <div className="text-danger">
                              {formik.errors.decorPolicy}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Alcohol Policy{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={alcoholPolicyOption}
                            selected
                            value={formik.values.alcoholPolicy}
                            onChange={(alcoholPolicy) =>
                              formik.setFieldValue(
                                "alcoholPolicy",
                                alcoholPolicy
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.alcoholPolicy &&
                            formik.errors.alcoholPolicy ? (
                            <div className="text-danger">
                              {formik.errors.alcoholPolicy}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            DJ Policy <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={true}
                            isMulti
                            options={djPolicyOption}
                            selected
                            value={formik.values.djPolicy}
                            onChange={(djPolicy) =>
                              formik.setFieldValue("djPolicy", djPolicy)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.djPolicy && formik.errors.djPolicy ? (
                            <div className="text-danger">
                              {formik.errors.djPolicy}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Max Capacity <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Venue Capacity"
                            name="venueCapacity"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.venueCapacity}
                          />
                          {formik.touched.venueCapacity &&
                            formik.errors.venueCapacity ? (
                            <div className="text-danger">
                              {formik.errors.venueCapacity}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Star Rating <span className="text-danger">*</span>
                          </label>
                          <select
                            name="starRating"
                            className="form-select"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.starRating}
                          >
                            <option value="" disabled hidden>
                              Select Option
                            </option>
                            <option value="1">1 Star</option>
                            <option value="2">2 Star</option>
                            <option value="3">3 Star</option>
                            <option value="4">4 Star</option>
                            <option value="5">5 Star</option>
                          </select>

                          {formik.touched.starRating &&
                            formik.errors.starRating ? (
                            <div className="text-danger">
                              {formik.errors.starRating}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            BuyOut Price (Optional)
                            {/* <span className="text-danger">*</span> */}
                          </label>
                          <div className="input-group mb-2">
                            <div className="input-group-prepend">
                              <div className="input-group-text">{currency?.symbol}</div>
                            </div>
                            <input
                              type="number"
                              placeholder="BuyOut Price"
                              name="startingPrice"
                              className="form-control"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.startingPrice}
                            />
                          </div>
                          {formik.touched.startingPrice &&
                            formik.errors.startingPrice ? (
                            <div className="text-danger">
                              {formik.errors.startingPrice}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="form-group text-center">
                      <button
                        type="submit"
                        className="btn text-white"
                        style={{ backgroundColor: "#085f9a" }}
                      >
                        {ttkEditMode ? "Save Changes" : "Submit"}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(VenueTTK);